module.exports = __webpack_public_path__ + "assets/img/head3-en.0a92c033.png";